export { PageViewEventSuspenseWrapper as PageViewEvent } from './page-view-event-suspense-wrapper';
